import { twMerge } from "tailwind-merge";

type MailToProps = {
  email: string;
  subject?: string;
  body?: string;
  className?: string;
};

function MailTo({
  email,
  subject = "",
  body = "",
  className
}: Readonly<MailToProps>) {
  const href = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={twMerge(
        "text-[12px] font-semibold text-txtBody hover:text-blue-600",
        className
      )}
    >
      {email}
    </a>
  );
}

export default MailTo;
